import 'react-toastify/dist/ReactToastify.css';

import {
  Redirect,
  Route,
  BrowserRouter as Router,
  Switch,
} from 'react-router-dom';

import Attribute from '../pages/Attribute/Attribute';
import AuthSignIn from '../pages/AuthSignIn/AuthSignIn';
import Cookies from 'js-cookie';
import CustomerUsers from '../pages/CustomerUsers/CustomerUsers';
import Customers from '../pages/Customers/Customers';
import Dashboard from '../pages/Dashboard/Dashboard';
import Device from '../pages/Device/Device';
import Document from '../pages/Document/Document';
import Header from '../components/Layouts/Header/Header';
import MapPage from '../pages/Map/MapPage';
import PageNotFound from '../pages/PageNotFound/PageNotFound';
import { PageURL } from '../constants/path';
import { PrivateRoute } from './PrivateRoute';
import Profile from '../pages/Profile/Profile';
import React from 'react';
import Report from '../pages/Report/Report';
import { ToastContainer } from 'react-toastify';
import { useSelector } from 'react-redux';

const Routers = () => {
  const typeAcc = useSelector((state) => state.profile.profile.authority);
  const tokenRedux = useSelector((state) => state.auth.token.token);
  const refreshToken = Cookies.get('refreshToken');

  return (
    <Router>
      {(tokenRedux ? tokenRedux : refreshToken) ? (
        <>
          <Header />
          <Switch>
            <Route exact path={PageURL.DASHBOARD} component={Dashboard} />
            <Route path={PageURL.MAP} component={MapPage} />
            <PrivateRoute
              path={PageURL.REPORT}
              component={Report}
              role={typeAcc}
            />
            <PrivateRoute
              path={PageURL.DOCUMENT}
              component={Document}
              role={typeAcc}
            />
            <Route path={PageURL.PROFILE} component={Profile} />
            <Route
              path={PageURL.DEVICE}
              component={(props) => <Device {...props} />}
              role={typeAcc}
            />
            <Route path={PageURL.ATTRIBUTE} component={Attribute} />
            <PrivateRoute
              path={PageURL.USERS}
              component={CustomerUsers}
              role={typeAcc}
            />
            <PrivateRoute
              path={PageURL.CUSTOMERS}
              component={Customers}
              role={typeAcc}
            />
            <Route>
              <Route component={PageNotFound} />
              <Redirect to={PageURL.PAGENOTFOUND} />
            </Route>
          </Switch>
        </>
      ) : (
        <Switch>
          <Route path={PageURL.AUTH_SIGNIN} component={AuthSignIn} />
          <Route>
            <Route component={PageNotFound} />
            <Redirect to={PageURL.PAGENOTFOUND} />
          </Route>
        </Switch>
      )}
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </Router>
  );
};

export default Routers;
